var FWG_CONFIG = {
  SUPABASE_URL: 'https://yjpllbljqrczkfhodozi.supabase.co',
  SUPABASE_ANON_KEY: 'sb_publishable_9aGFQdl82HAw23uFfSIjCA_d4Qmi6Bp',
  API_URL: 'https://ops.frederickwraps.com',
  THANK_YOU_URL: '/pages/thank-you',
  STORAGE_BUCKET: 'form-uploads'
};

var STEPS = 4, cur = 1, done = new Set();

/* ── Product Config ── */
var PRODUCTS = [
  { id:'polos', name:'Polo Shirts', placements:['left_chest','right_chest','center_chest','full_back','upper_back','sleeve','collar_nape'] },
  { id:'hats', name:'Hats / Caps', placements:['hat_front','hat_side','hat_back'] },
  { id:'hoodies', name:'Hoodies / Sweaters', placements:['left_chest','right_chest','center_chest','full_back','upper_back','sleeve','hood'] },
  { id:'jackets', name:'Jackets', placements:['left_chest','right_chest','center_chest','full_back','upper_back','sleeve','collar_nape'] },
  { id:'bags', name:'Bags / Totes', placements:['front','back','strap'] },
  { id:'aprons', name:'Aprons / Workwear', placements:['center_chest','pocket','full_front'] },
  { id:'blankets', name:'Blankets / Towels', placements:['corner','center'] },
  { id:'other_product', name:'Other', placements:['other_custom'] }
];

var QTY_OPTIONS = ['1-3','4-11','12-24','25-49','50-99','100-249','250-499','500+','Not sure'];

var PLACEMENT_LABELS = {
  left_chest:'Left Chest', right_chest:'Right Chest', center_chest:'Center Chest',
  full_back:'Full Back', upper_back:'Upper Back', sleeve:'Sleeve(s)', collar_nape:'Collar / Nape',
  hood:'Hood', hat_front:'Hat Front', hat_side:'Hat Side', hat_back:'Hat Back',
  front:'Front', back:'Back', strap:'Strap', pocket:'Pocket', full_front:'Full Front',
  corner:'Corner', center:'Center', other_custom:'Other / Custom'
};

var DIGITIZING_LABELS = { have_file:'Has embroidery-ready file', needs_digitizing:'Needs digitizing', not_sure:'Not sure' };
var GARMENT_LABELS = { customer_supplies:'Customer providing', fwg_sources:'FWG sourcing', not_sure:'Not sure yet' };
var TIMELINE_LABELS = {
  same_day:'\uD83D\uDEA8 Same Day \u2014 URGENT', urgent:'\uD83D\uDD34 Urgent (24\u201348 hrs)', rush:'\uD83D\uDD36 Rush (2\u20133 days)',
  standard:'Standard (5\u20137 days)', '30_days':'Within 30 days', '30_60_days':'30\u201360 days',
  '60_90_days':'60\u201390+ days', flexible:'No Rush \u2014 Flexible'
};

/* State: per-product selections */
var productState = {}; // { productId: { selected:bool, placements:Set, qty:string } }

/* ── Build Product Cards ── */
function buildProductCards() {
  var list = document.getElementById('productList');
  PRODUCTS.forEach(function(p) {
    productState[p.id] = { selected:false, placements:new Set(), qty:'' };

    var card = document.createElement('div');
    card.className = 'product-card';
    card.id = 'pc_' + p.id;

    // Header
    var header = document.createElement('div');
    header.className = 'product-card__header';
    header.onclick = function() { toggleProduct(p.id); };
    header.innerHTML = '<span class="product-card__check"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg></span>'
      + '<span class="product-card__name">' + p.name + '</span>'
      + '<span class="product-card__badge">Configured \u2713</span>';

    // Detail panel
    var detail = document.createElement('div');
    detail.className = 'product-card__detail';

    // Placements
    var placeSection = document.createElement('div');
    placeSection.className = 'detail-section';
    var placeLabel = '<span class="detail-label">Placement <span style="color:var(--fwg-red);">*</span></span>';
    var placeGrid = '<div class="mini-ms" id="place_' + p.id + '">';
    p.placements.forEach(function(pl) {
      placeGrid += '<div class="mini-ms-btn" data-value="' + pl + '" onclick="togglePlacement(\'' + p.id + '\',this)">'
        + '<span class="mini-ms-btn__dot"><svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg></span> '
        + (PLACEMENT_LABELS[pl] || pl) + '</div>';
    });
    placeGrid += '</div>';
    placeSection.innerHTML = placeLabel + placeGrid;

    // Other custom text if product is "other"
    if (p.id === 'other_product') {
      placeSection.innerHTML = '<div class="field-group" style="margin-bottom:0;"><span class="detail-label">Describe your product & placement</span>'
        + '<input type="text" id="otherProductDesc" placeholder="e.g. Canvas tote bag, centered on front"></div>';
    }

    // Quantity
    var qtySection = document.createElement('div');
    qtySection.className = 'detail-section';
    var qtyLabel = '<span class="detail-label">Quantity <span style="color:var(--fwg-red);">*</span></span>';
    var qtyPills = '<div class="mini-pills" id="qty_' + p.id + '">';
    QTY_OPTIONS.forEach(function(q) {
      qtyPills += '<div class="mini-pill" data-value="' + q + '" onclick="pickProductQty(\'' + p.id + '\',this)">' + q + '</div>';
    });
    qtyPills += '</div>';
    qtySection.innerHTML = qtyLabel + qtyPills;

    detail.appendChild(placeSection);
    detail.appendChild(qtySection);
    card.appendChild(header);
    card.appendChild(detail);
    list.appendChild(card);
  });
}

/* ── Toggle Product ── */
function toggleProduct(id) {
  var state = productState[id];
  var card = document.getElementById('pc_' + id);
  if (state.selected) {
    state.selected = false;
    state.placements.clear();
    state.qty = '';
    card.classList.remove('selected','configured');
    // Reset inner selections
    card.querySelectorAll('.mini-ms-btn.selected, .mini-pill.selected').forEach(function(b) { b.classList.remove('selected'); });
  } else {
    state.selected = true;
    card.classList.add('selected');
  }
  clearErrors();
}

/* ── Toggle Placement ── */
function togglePlacement(productId, el) {
  var v = el.dataset.value;
  var state = productState[productId];
  if (state.placements.has(v)) { state.placements.delete(v); el.classList.remove('selected'); }
  else { state.placements.add(v); el.classList.add('selected'); }
  updateBadge(productId);
}

/* ── Pick Qty ── */
function pickProductQty(productId, el) {
  var container = el.closest('.mini-pills');
  container.querySelectorAll('.mini-pill').forEach(function(b) { b.classList.remove('selected'); });
  el.classList.add('selected');
  productState[productId].qty = el.dataset.value;
  updateBadge(productId);
}

function updateBadge(id) {
  var state = productState[id];
  var card = document.getElementById('pc_' + id);
  var isOther = id === 'other_product';
  if (isOther) {
    var desc = document.getElementById('otherProductDesc');
    if (desc && desc.value.trim() && state.qty) card.classList.add('configured');
    else card.classList.remove('configured');
  } else {
    if (state.placements.size > 0 && state.qty) card.classList.add('configured');
    else card.classList.remove('configured');
  }
}

/* ── Standard Helpers ── */
function pickCM(btn) {
  document.querySelectorAll('.fp .cm-btn').forEach(function(b) { b.classList.remove('selected'); });
  btn.classList.add('selected');
  document.getElementById('embContactMethod').value = btn.dataset.value;
}

function pickPill(el, hiddenId) {
  el.closest('.pill-group').querySelectorAll('.pill-btn').forEach(function(b) { b.classList.remove('selected'); });
  el.classList.add('selected');
  document.getElementById(hiddenId).value = el.dataset.value;
}

function pickRadio(el, hiddenId) {
  el.closest('.radio-group').querySelectorAll('.radio-btn').forEach(function(b) { b.classList.remove('selected'); });
  el.classList.add('selected');
  document.getElementById(hiddenId).value = el.dataset.value;
  if (hiddenId === 'embGarmentSupply') {
    var panel = document.getElementById('sourcingPanel');
    if (el.dataset.value === 'fwg_sources') panel.classList.add('visible');
    else panel.classList.remove('visible');
  }
}

function formatPhone(input) {
  var v = input.value.replace(/\D/g, '');
  if (v.length > 10) v = v.substring(0, 10);
  if (v.length >= 7) input.value = '(' + v.substring(0,3) + ') ' + v.substring(3,6) + '-' + v.substring(6);
  else if (v.length >= 4) input.value = '(' + v.substring(0,3) + ') ' + v.substring(3);
  else if (v.length > 0) input.value = '(' + v;
}

function handleFiles(input) {
  var el = document.getElementById('embFileNames');
  el.textContent = input.files.length ? 'Selected: ' + Array.from(input.files).map(function(f) { return f.name; }).join(', ') : '';
}

/* ── Navigation ── */
function goToStep(target) {
  if (target < 1 || target > STEPS || target === cur) return;
  if (target > cur) {
    for (var s = cur; s < target; s++) {
      var errs = validate(s);
      if (errs.length) { highlight(s, errs); showToast('Please fill in all required fields'); return; }
      done.add(s);
    }
  }
  if (target < cur && !validate(cur).length) done.add(cur);
  switchCard(target);
}

function switchCard(target) {
  var c = document.querySelector('.fp .step-card[data-step="'+cur+'"]');
  if (c) c.classList.remove('active');
  if (target === STEPS) buildSummary();
  var t = document.querySelector('.fp .step-card[data-step="'+target+'"]');
  if (t) { void t.offsetWidth; t.classList.add('active'); }
  cur = target;
  document.querySelectorAll('.fp .step-ind').forEach(function(ind) {
    var s = parseInt(ind.dataset.step);
    ind.classList.remove('active','completed');
    if (s === cur) ind.classList.add('active');
    else if (done.has(s)) ind.classList.add('completed');
  });
  document.getElementById('embStepper').scrollIntoView({ behavior:'smooth', block:'start' });
}

/* ── Validation ── */
function validate(step) {
  var e = [];
  if (step === 1) {
    if (!document.getElementById('embName').value.trim()) e.push('embName');
    var em = document.getElementById('embEmail').value.trim();
    if (!em || em.indexOf('@') === -1) e.push('embEmail');
    if (!document.getElementById('embContactMethod').value) e.push('contactMethod');
  }
  if (step === 2) {
    var anySelected = false;
    var allConfigured = true;
    PRODUCTS.forEach(function(p) {
      var state = productState[p.id];
      if (state.selected) {
        anySelected = true;
        if (p.id === 'other_product') {
          var desc = document.getElementById('otherProductDesc');
          if (!desc || !desc.value.trim() || !state.qty) allConfigured = false;
        } else {
          if (state.placements.size === 0 || !state.qty) allConfigured = false;
        }
      }
    });
    if (!anySelected) e.push('noProducts');
    else if (!allConfigured) e.push('incompleteProducts');
    if (!document.getElementById('embGarmentSupply').value) e.push('garmentGroup');
  }
  if (step === 3) {
    if (!document.getElementById('embDigitizing').value) e.push('digitizingGroup');
    if (!document.getElementById('embTimeline').value) e.push('embTimeline');
  }
  return e;
}

function highlight(step, errs) {
  clearErrors();
  var card = document.querySelector('.fp .step-card[data-step="'+step+'"]');
  if (card) { card.classList.remove('shake'); void card.offsetWidth; card.classList.add('shake'); }
  errs.forEach(function(k) {
    var el = document.getElementById(k);
    if (el && el.closest('.field-group')) el.closest('.field-group').classList.add('field-error');
    if (k === 'contactMethod') { var g = document.querySelector('.fp .cm-group'); if (g) g.closest('.field-group').classList.add('field-error'); }
    if (k === 'noProducts' || k === 'incompleteProducts') {
      var pl = document.getElementById('productList');
      if (pl) { pl.style.outline='2px solid var(--fwg-red)'; pl.style.outlineOffset='4px'; pl.style.borderRadius='12px'; }
      if (k === 'incompleteProducts') showToast('Please complete placement & quantity for all selected products');
    }
    ['garmentGroup','digitizingGroup'].forEach(function(id) {
      if (k === id) { var g = document.getElementById(id); if (g) { g.style.outline='2px solid var(--fwg-red)'; g.style.outlineOffset='4px'; g.style.borderRadius='12px'; }}
    });
  });
}

function clearErrors() {
  document.querySelectorAll('.fp .field-error').forEach(function(el) { el.classList.remove('field-error'); });
  ['productList','garmentGroup','digitizingGroup'].forEach(function(id) {
    var g = document.getElementById(id); if (g) { g.style.outline=''; g.style.outlineOffset=''; }
  });
}
document.addEventListener('input', function(e) { if (e.target.closest('.fp')) clearErrors(); });
document.addEventListener('click', function(e) { if (e.target.closest('.fp .ms-btn, .fp .pill-btn, .fp .radio-btn, .fp .cm-btn, .fp .product-card, .fp .mini-ms-btn, .fp .mini-pill')) clearErrors(); });

/* ── Summary ── */
function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
function row(l, v) { return '<div class="summary__row"><span class="summary__label">'+l+'</span><span class="summary__value">'+(v||'\u2014')+'</span></div>'; }
function editBtn(s) { return '<button type="button" class="btn-edit" onclick="goToStep('+s+')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.83 2.83 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></svg> Edit</button>'; }
function secHead(n, t, s) { return '<div class="summary__section-header"><div class="summary__section-title"><span class="summary__section-num">'+n+'</span> '+t+'</div>'+editBtn(s)+'</div>'; }

function getProductLabel(id) {
  for (var i = 0; i < PRODUCTS.length; i++) { if (PRODUCTS[i].id === id) return PRODUCTS[i].name; }
  return id;
}

function buildSummary() {
  var h = '';
  // Contact
  h += '<div class="summary__section">' + secHead('01','Contact Info',1);
  h += row('Name', esc(document.getElementById('embName').value));
  h += row('Email', esc(document.getElementById('embEmail').value));
  var ph = document.getElementById('embPhone').value.trim();
  if (ph) h += row('Phone', esc(ph));
  var co = document.getElementById('embCompany').value.trim();
  if (co) h += row('Company', esc(co));
  var cm = document.getElementById('embContactMethod').value;
  h += row('Contact Via', cm === 'email' ? 'Email' : cm === 'text' ? 'Text' : 'Call');
  h += '</div>';

  // Products
  h += '<div class="summary__section">' + secHead('02','Products & Placement',2);
  PRODUCTS.forEach(function(p) {
    var state = productState[p.id];
    if (!state.selected) return;
    h += '<div class="summary__product">';
    h += '<div class="summary__product-name">' + esc(p.name) + '</div>';
    if (p.id === 'other_product') {
      var desc = document.getElementById('otherProductDesc');
      h += row('Details', esc(desc ? desc.value : ''));
    } else {
      var places = [];
      state.placements.forEach(function(v) { places.push(PLACEMENT_LABELS[v] || v); });
      h += row('Placement', places.join(', '));
    }
    h += row('Quantity', state.qty);
    h += '</div>';
  });
  var gs = document.getElementById('embGarmentSupply').value;
  h += row('Garments', GARMENT_LABELS[gs] || gs);
  var sn = document.getElementById('embSourcingNotes').value.trim();
  if (gs === 'fwg_sources' && sn) h += row('Sourcing Notes', esc(sn));
  h += '</div>';

  // Design
  h += '<div class="summary__section">' + secHead('03','Design Details',3);
  var dg = document.getElementById('embDigitizing').value;
  h += row('Digitizing', DIGITIZING_LABELS[dg] || dg);
  var fi = document.querySelector('input[name="emb_design_files"]');
  if (fi && fi.files.length) h += row('Files', Array.from(fi.files).map(function(f) { return esc(f.name); }).join(', '));
  var tl = document.getElementById('embTimeline').value;
  h += row('Timeline', TIMELINE_LABELS[tl] || tl);
  var notes = document.getElementById('embNotes').value.trim();
  if (notes) h += row('Notes', esc(notes));
  h += '</div>';

  document.getElementById('embSummary').innerHTML = h;
}

/* ── Toast ── */
function showToast(m) {
  var t = document.getElementById('embToast');
  t.textContent = m;
  t.classList.add('show');
  setTimeout(function() { t.classList.remove('show'); }, 2500);
}

/* ── File Upload to Supabase ── */
function uploadFile(file, folder) {
  var timestamp = Date.now();
  var safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
  var path = folder + '/' + timestamp + '_' + safeName;
  return fetch(
    FWG_CONFIG.SUPABASE_URL + '/storage/v1/object/' + FWG_CONFIG.STORAGE_BUCKET + '/' + path,
    {
      method: 'POST',
      headers: {
        'apikey': FWG_CONFIG.SUPABASE_ANON_KEY,
        'Authorization': 'Bearer ' + FWG_CONFIG.SUPABASE_ANON_KEY,
        'Content-Type': file.type,
        'x-upsert': 'true'
      },
      body: file
    }
  ).then(function(response) {
    if (!response.ok) { return response.text().then(function(t) { console.error('Upload failed:', file.name, t); return null; }); }
    return FWG_CONFIG.SUPABASE_URL + '/storage/v1/object/public/' + FWG_CONFIG.STORAGE_BUCKET + '/' + path;
  });
}

function uploadFiles(fileInput, folder) {
  if (!fileInput || !fileInput.files || fileInput.files.length === 0) return Promise.resolve([]);
  var promises = [];
  for (var i = 0; i < fileInput.files.length; i++) { promises.push(uploadFile(fileInput.files[i], folder)); }
  return Promise.all(promises).then(function(urls) { return urls.filter(function(u) { return u !== null; }); });
}

/* ── Submit ── */
document.addEventListener('DOMContentLoaded', function() {
  buildProductCards();

  document.getElementById('fwgEmbForm').addEventListener('submit', function(e) {
    e.preventDefault();
    for (var i = 1; i <= STEPS; i++) {
      var errs = validate(i);
      if (errs.length) { switchCard(i); setTimeout(function() { highlight(i, errs); }, 50); showToast('Please fill in all required fields'); return; }
    }

    var submitBtn = document.querySelector('.fp .btn-submit');
    var originalText = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span style="display:inline-flex;align-items:center;gap:8px;"><svg width="18" height="18" viewBox="0 0 24 24" style="animation:spin 1s linear infinite;"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none" stroke-dasharray="31 31" stroke-linecap="round"/></svg> Submitting...</span>';
    }

    var items = [];
    PRODUCTS.forEach(function(p) {
      var state = productState[p.id];
      if (!state.selected) return;
      var placements = [];
      state.placements.forEach(function(v) { placements.push(v); });
      var item = { product: p.id, quantity: state.qty };
      if (p.id === 'other_product') {
        var desc = document.getElementById('otherProductDesc');
        item.description = desc ? desc.value.trim() : '';
      } else {
        item.placements = placements;
      }
      items.push(item);
    });

    var submissionId = Date.now() + '_' + Math.random().toString(36).substring(2, 8);
    var folder = 'submissions/' + submissionId;
    var fileInput = document.querySelector('input[name="emb_design_files"]');

    uploadFiles(fileInput, folder + '/designs')
    .then(function(designUrls) {
      var payload = {
        form_type: 'embroidery',
        contact_name: document.getElementById('embName').value.trim(),
        email: document.getElementById('embEmail').value.trim(),
        phone: document.getElementById('embPhone').value.trim() || null,
        company: document.getElementById('embCompany').value.trim() || null,
        contact_method: document.getElementById('embContactMethod').value,
        items: items,
        garment_supply: document.getElementById('embGarmentSupply').value,
        sourcing_notes: document.getElementById('embSourcingNotes').value.trim() || null,
        digitizing: document.getElementById('embDigitizing').value,
        timeline: document.getElementById('embTimeline').value,
        notes: document.getElementById('embNotes').value.trim() || null,
        additional_info: document.getElementById('embAdditional').value.trim() || null,
        design_file_urls: designUrls,
        source_page: window.location.pathname,
        user_agent: navigator.userAgent
      };

      return fetch(FWG_CONFIG.API_URL + '/api/submissions/public', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    })
    .then(function(response) {
      if (!response.ok) { return response.text().then(function(t) { throw new Error('Submission failed: ' + t); }); }
      showToast('Inquiry submitted! We\'ll be in touch within 24 hours.');
      setTimeout(function() { window.location.href = FWG_CONFIG.THANK_YOU_URL; }, 800);
    })
    .catch(function(err) {
      console.error('Form submission error:', err);
      showToast('Something went wrong. Please try again or call us directly.');
      if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = originalText; }
    });
  });
});
